var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-window"},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){return _vm.closeModal()}}},[_c('CloseCrossSvg')],1),_vm._t("modalContent")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }